import { render, staticRenderFns } from "./productManagement.vue?vue&type=template&id=79517fe2"
import script from "./productManagement.vue?vue&type=script&lang=js"
export * from "./productManagement.vue?vue&type=script&lang=js"
import style0 from "./productManagement.vue?vue&type=style&index=0&id=79517fe2&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports